import React from 'react';

interface TableLoaderProps {
  columns: number;
  rows?: number;
}

const TableLoader: React.FC<TableLoaderProps> = ({ columns, rows = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex} className="border-b last:border-b-0 animate-pulse">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} className="px-5 py-4">
              <div className="h-4 bg-muted/60 rounded w-full max-w-[80%]"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TableLoader;
